import { render, staticRenderFns } from "./UserProfileImage.vue?vue&type=template&id=5dea7f85&scoped=true&"
import script from "./UserProfileImage.vue?vue&type=script&lang=js&"
export * from "./UserProfileImage.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileImage.vue?vue&type=style&index=0&id=5dea7f85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dea7f85",
  null
  
)

export default component.exports